(() => {
    class Tabs {
        /**
         * Init the class
         *
         * @param {HTMLElement} rootEl The root element of the block
         */
        constructor(rootEl) {
            // Define classes, selectors, and magic
            this.rootEl = rootEl;
            this.tabBtns = rootEl.querySelectorAll('.ed-tab-btn');
            this.tabContentItems = rootEl.querySelectorAll('.ed-tab-content');
            this.activeClass = 'active-item';
            this.tabMobileBtns = rootEl.querySelectorAll('.ed-tab-mobile-title');
            
            // Check if event listeners have already been attached
            if (!rootEl.hasAttribute('data-tabs-initialized')) {
                const self = this;
                
                this.tabBtns.forEach((btn) => {
                    btn.addEventListener('click', function () {
                        self.toggleContent(this);
                    });
                });
                
                // Remove existing click event listeners to avoid duplicates
                this.tabMobileBtns.forEach((btn) => {
                    btn.addEventListener('click', function () {
                        console.log('button clicked')
                        self.toggleMobileContent(this);
                    });
                });
        
                // Mark element as initialised to prevent re-attaching event listeners
                rootEl.setAttribute('data-tabs-initialized', true);
            }
        }

        /*
        * Toggles tab content
        * @param {HTMLElement} btn The tab button element
        * @return    {void}
        */
        toggleContent(btn) {
            const id = btn.dataset.id;
            this.tabBtns.forEach((item) => item.classList.remove(this.activeClass));
            btn.classList.add(this.activeClass);
            this.tabContentItems.forEach((item) => {
                const itemId = item.dataset.id;
                if (id === itemId) {
                    item.classList.add(this.activeClass);
                } else {
                    item.classList.remove(this.activeClass);
                }
            });

            const headerHeight = document
                .getElementById('main-navigation')
                .getBoundingClientRect().height;
            const y =
                this.rootEl.getBoundingClientRect().top +
                window.pageYOffset -
                headerHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }

        /*
        * Toggles mobile tab content
        * @param {HTMLElement} btn The tab button element
        * @return    {void}
        */
        toggleMobileContent(btn) {
            const id = btn.dataset.id;
            this.tabContentItems.forEach((item) => {
                const itemId = item.dataset.id;

                const alreadyOpen = item.classList.contains(this.activeClass);

                if (id === itemId) {
                    if (!alreadyOpen) {
                        btn.classList.add(this.activeClass);
                        item.classList.add(this.activeClass);
                    } else {
                        btn.classList.remove(this.activeClass);
                        item.classList.remove(this.activeClass);
                    }
                }
            });
        }
    }
    
    const selector = 'ed-tabs';
    const blockEls = document.querySelectorAll(`.${selector}`);
    blockEls.forEach((blockEl) => new Tabs(blockEl));
})();